module.exports = __webpack_public_path__ + "img/footer__application3.e4d83ae.webp";